<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title1"> Каталог продукции,
                                <span v-if="total">
                          записей {{ total }}
                      </span>
                            </h3>
                            <br>
                        </div>
                        <!-- /.card-header -->
                        <div class="form-inline">
                            <div class="form-group" style="float: right">
                                <select v-model="length" @change="getResults()" class="form-control"
                                        style="width: 12em">
                                    <option value="">Количество полей</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>

                            </div>
                        </div>

                      <div class="card-body table-responsive p-0">
                        <table class="table">
                          <thead>
                          <tr>
                            <th><input type="number" v-model="search.id"  placeholder="id"
                                       class="form-control" @input="getResults()"></th>
                            <th><input type="text" v-model="search.name"
                                       placeholder="Наименование" class="form-control" @input="getResults()">
                            </th>
                            <th><input type="number" v-model="search.weight"  placeholder="Вес"
                                       class="form-control" @input="getResults()"></th>
                            <th><input type="number" v-model="search.price"  placeholder="Цена"
                                       class="form-control" @input="getResults()"></th>
                            <th>

															<v-select
																			label="name"
																			:options="categories"
																			:reduce="(option) => option.id"
																			v-model="search.cid"
																			aria-required="true"
																			class="form-control"
																			@input="getResults()"
															/>
                            </th>
                            <th>
                              <a href="#" class="btn btn-sm btn-success" @click="clearSearchItem">
                                <i class="fa fa-trash "></i>
                              </a>
                              <a href="#" class="btn btn-sm btn-primary" @click="$refs.modal.openModal();clearForm()">
                                <i class="fa fa-plus-square"></i>
                                Добавить
                              </a>

                            </th>
                          </tr>
                          </thead>
                        </table>
                      </div>

                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                  <th @click="getResults(current_page, 'id')">id
                                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                                            :class="[ (sort.id=='ASC') ? 'transform' : 'transformold' ]"
                                            class="gridjs-th gridjs-th-sort"></button>
                                  </th>
                                  <th @click="getResults(current_page, 'name')">Наименование
                                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                                            :class="[ (sort.family=='ASC') ? 'transform' : 'transformold' ]"
                                            class="gridjs-th gridjs-th-sort"></button>
                                  </th>
                                  <th @click="getResults(current_page, 'weight')">Вес
                                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                                            :class="[ (sort.weight=='ASC') ? 'transform' : 'transformold' ]"
                                            class="gridjs-th gridjs-th-sort"></button>
                                  </th>
                                  <th @click="getResults(current_page, 'price')">Цена
                                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                                            :class="[ (sort.price=='ASC') ? 'transform' : 'transformold' ]"
                                            class="gridjs-th gridjs-th-sort"></button>
                                  </th>
                                  <th @click="getResults(current_page, 'category')">Категория
                                    <button :tabindex="-1" aria-label="Sort " title="Sort "
                                            :class="[ (sort.category=='ASC') ? 'transform' : 'transformold' ]"
                                            class="gridjs-th gridjs-th-sort"></button>
                                  </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="catalog in catalogs.data" :key="catalog.id">
                                    <td>{{ catalog.id }}</td>
                                    <td>{{ catalog.name }}</td>
                                    <td>{{ catalog.weight }}</td>
                                    <td>{{ catalog.price }}</td>
                                    <td>{{ catalog.category }}</td>
                                    <td style="text-align: right">
                                      <a href="#" @click="editModal(catalog);$refs.modal.openModal();">
                                            <i class="fa fa-edit blue"></i>
                                        </a>/
                                        <a href="#" @click="deleteProduct(catalog)">
                                            <i class="fa fa-trash red"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer">
                            <pagination :data="catalogs" @pagination-change-page="getResults" :limit="5">
                                <span slot="prev-nav">&lt; Назад</span>
                                <span slot="next-nav">Вперед &gt;</span>
                            </pagination>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>

            <!-- Modal -->
          <right-modal-widget  v-bind:id="'production-edit-modal'" v-bind:title="!editmode?'Создать запись':'Редактировать запись'" ref="modal">


          <form @submit.prevent="editmode ? updateProduct() : createProduct()">
                            <div class="modal-body">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label>Категория</label>
<!--                                        <select class="form-control" v-model="form.category_id">-->
<!--                                            <option-->
<!--                                                v-for="(cat,index) in categories" :key="index"-->
<!--                                                :value="index"-->
<!--                                                :selected="index == form.category_id">{{ cat }}-->
<!--                                            </option>-->
<!--                                        </select>-->

																			<v-select
																							label="name"
																							:options="categories"
																							:reduce="(option) => option.id"
																							v-model="form.cid"
																							aria-required="true"
																							class="form-control"
																			/>
                                        <has-error :form="form" field="category_id"></has-error>
                                    </div>
                                    <label>Наименование</label>
                                    <input v-model="form.name" type="text" name="name"
                                           class="form-control" :class="{ 'is-invalid': form.errors.has('name') }"
                                           disabled>
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Вес</label>
                                    <input v-model="form.weight" type="text" name="description"
                                           class="form-control" :class="{ 'is-invalid': form.errors.has('weight') }">
                                    <has-error :form="form" field="weight"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Цена</label>
                                    <input v-model="form.price" type="text" name="price"
                                           class="form-control" :class="{ 'is-invalid': form.errors.has('price') }">
                                    <has-error :form="form" field="price"></has-error>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$refs.modal.closeModal()">Закрыть</button>
                                <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
                            </div>
                        </form>
          </right-modal-widget>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            editmode: false,
            catalogs: [],
            form: new Form({
                id: '',
                category: '',
                name: '',
                photo: '',
                weight: '',
                cid: '',
                catalog_name_id: '',
                price: '',
                photoUrl: '',
            }),
            search: {
                id: '',
                name: '',
                weight: '',
                price: '',
                cid: '',
            },
          sort: {
            id: 'ASC',
            name: 'ASC',
            weight: 'ASC',
            price: 'ASC',
            category: 'ASC',
          },
            length: '',
            total: '',
            current_page: '',
            categories: [],
            sortable: '',
        }
    },
    methods: {
        clearSearchItem() {
            this.search.id = '';
            this.search.name = '';
            this.search.weight = '';
            this.search.price = '';
            this.search.cid = '';
            this.getResults(1);
        },
      fsort(name) {
        if (this.sort[name] == 'ASC') {
          this.sort[name] = 'DESC';
        } else {
          this.sort[name] = 'ASC'
        }
      },
      async getResults(page, sort) {
        this.fsort(sort);
        if (page == undefined) {
          page = this.current_page;
        } else {
          this.current_page = page;
        }
            this.$Progress.start();
            axios.get('/api/catalog?page=' + page, {
                params: {
                  sort: sort,
                  sortable: this.sortable,
                  pagination: this.length,
                  search: this.search
                }
            })
                .then(({data}) => (
                    this.catalogs = data.data,
                        this.length = data.data.per_page,
                        this.total = data.data.total,
                        this.current_page = data.data.current_page,
                         this.sortable = data['message']

      ));
            this.$Progress.finish();
        },
        loadCategories() {
            axios.get("/api/category/list").then(({data}) => (this.categories = data.data));
        },
        editModal(product) {
            this.editmode = true;
            this.form.reset();
            $('#addNew').modal('show');
            this.form.fill(product);
        },
        newModal() {
            this.editmode = false;
            this.form.reset();
            $('#addNew').modal('show');
        },
        createProduct() {
            this.$Progress.start();
            this.form.post('/api/catalog')
                .then((data) => {
                    if (data.data.success) {
                        $('#addNew').modal('hide');

                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.$Progress.finish();
                        this.getResults(response.data.data);
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                        this.$Progress.failed();
                    }
                })
                .catch(() => {
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
        },
        updateProduct() {
            this.$Progress.start();
            this.form.put('/api/catalog/' + this.form.id, {
                params: {
                    current_page: this.current_page,
                }
            })
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    this.$Progress.finish();
                  this.$refs.modal.closeModal();
                  this.getResults(response.data.data);
                })
                .catch(() => {
                    this.$Progress.fail();
                });
        },
        deleteProduct(catalogs) {
            Swal.fire({
                title: 'Вы хотите удалить?',
                text: catalogs.name + ' ' + catalogs.weight + ' грамм',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                cancelButtonText: 'Отмена',
                confirmButtonText: 'Да, уверен!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    this.form.delete('/api/catalog/' + catalogs.id,
                        {
                        params: {
                            current_page: this.current_page,
                        }}).then((response) => {
                        Swal.fire(
                            'Позиция' + catalogs.name + ' ' + catalogs.weight + ' грамм',
                            'Удалена',
                            'success'
                        );
                        // Fire.$emit('AfterCreate');
                        this.getResults(response.data.data.current_page);
                    }).catch((data) => {
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        }
    },
    created() {
        this.$Progress.start();
        this.getResults();
        this.loadCategories();
        this.$Progress.finish();
    },
}
</script>

<style>
.form-group {
    padding: 1em;
}

</style>
